// Module
var code = "<div layout=\"column\" flex layout-margin> <md-button ng-click=\"$ctrl.sendApplicationNmb()\" class=\"save\" layout-margin aria-label=\"Nmb\"> <md-icon>send</md-icon> <span>Send to NMB</span> <md-tooltip>Send to Nmb</md-tooltip> </md-button> </div>";
// Exports
module.exports = code;